import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import f from "./panelHeader.js";
import { useCalendarProps as m, useCalendar as k } from "./use-calendar.js";
import { warnOnce as $ } from "../../../_utils/naive/warn.js";
import C from "../../../_internal/focus-detector/src/FocusDetector.js";
import p, { XButton as y } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as u, resolveSlot as d } from "../../../_utils/vue/resolve-slot.js";
import _ from "../../../_internal/icons/FastBackward.js";
import w from "../../../_internal/icons/Backward.js";
import x from "../../../_internal/icons/Forward.js";
import S from "../../../_internal/icons/FastForward.js";
import { defineComponent as M, watchEffect as O, h as t } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const A = M({
  name: "DatePanel",
  props: Object.assign(Object.assign({}, m), {
    type: {
      type: String,
      required: !0
    }
  }),
  setup(n) {
    return process.env.NODE_ENV !== "production" && O(() => {
      var l;
      !((l = n.actions) === null || l === void 0) && l.includes("confirm") && $("date-picker", "The `confirm` action is not supported for n-date-picker of `date` type");
    }), k(n, n.type);
  },
  render() {
    var n, l, c;
    const {
      mergedClsPrefix: e,
      mergedTheme: o,
      shortcuts: r,
      onRender: h,
      datePickerSlots: i,
      type: v
    } = this;
    return h == null || h(), t("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--${v}`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, t("div", {
      class: `${e}-date-panel-calendar`
    }, t("div", {
      class: `${e}-date-panel-month`
    }, t("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, d(i["prev-year"], () => [t(_, null)])), t("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, d(i["prev-month"], () => [t(w, null)])), t(f, {
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), t("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.nextMonth
    }, d(i["next-month"], () => [t(x, null)])), t("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, d(i["next-year"], () => [t(S, null)]))), t("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((a) => t("div", {
      key: a,
      class: `${e}-date-panel-weekdays__day`
    }, a))), t("div", {
      class: `${e}-date-panel-dates`
    }, this.dateArray.map((a, s) => t("div", {
      "data-n-date": !0,
      key: s,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--current`]: a.isCurrentDate,
        [`${e}-date-panel-date--selected`]: a.selected,
        [`${e}-date-panel-date--excluded`]: !a.inCurrentMonth,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a.ts, {
          type: "date",
          year: a.dateObject.year,
          month: a.dateObject.month,
          date: a.dateObject.date
        }),
        [`${e}-date-panel-date--week-hovered`]: this.isWeekHovered(a),
        [`${e}-date-panel-date--week-selected`]: a.inSelectedWeek
      }],
      onClick: () => {
        this.handleDateClick(a);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(a);
      }
    }, t("div", {
      class: `${e}-date-panel-date__trigger`
    }), a.dateObject.date, a.isCurrentDate ? t("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? t("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((n = this.actions) === null || n === void 0) && n.length || r ? t("div", {
      class: `${e}-date-panel-actions`
    }, t("div", {
      class: `${e}-date-panel-actions__prefix`
    }, r && Object.keys(r).map((a) => {
      const s = r[a];
      return Array.isArray(s) ? null : t(y, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(s);
        },
        onClick: () => {
          this.handleSingleShortcutClick(s);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a
      });
    })), t("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((l = this.actions) === null || l === void 0) && l.includes("clear") ? u(this.$slots.clear, {
      onClear: this.handleClearClick,
      text: this.locale.clear
    }, () => [t(p, {
      theme: o.peers.Button,
      themeOverrides: o.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    })]) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? u(this.$slots.now, {
      onNow: this.handleNowClick,
      text: this.locale.now
    }, () => [t(p, {
      theme: o.peers.Button,
      themeOverrides: o.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    })]) : null)) : null, t(C, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  A as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/date.js
// module id = 1624
// module chunks = 41